import React, { FC } from 'react';
import { View, ViewProps } from 'react-native';

import { TWCStepIcon } from './components/TWCStepIcon';
import { styles } from './styles';
import { StepStatus } from './types';

export const TWCStep: FC<TWCStepProps> = ({ children, nativeID, testID, status, step }) => (
  <View nativeID={nativeID || testID} style={styles.stepContainer} testID={testID}>
    <TWCStepIcon status={status} step={step} style={styles.stepIcon} />
    <View style={styles.stepContent}>{children}</View>
  </View>
);

type TWCStepProps = {
  status: StepStatus;
  step?: number;
} & ViewProps;
